import { css } from 'styled-components';

export interface WidthsProps {
  containerWidth?: 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'article';
  isCentered?: boolean;
}

export const widths = css<WidthsProps>`
  width: ${(props) => (props.containerWidth ? '100%' : 'auto')};
  max-width: ${(props) => (props.containerWidth ? props.theme.widths[props.containerWidth] : null)};
  ${(props) => {
    if (props.isCentered) {
      return css`
        margin-left: auto;
        margin-right: auto;
      `;
    }

    return null;
  }}
`;
